import { styled } from "@mui/material";
import StringHelpers from "helpers/StringHelpers";
import { useMemo } from "react";

const HighlightedSpan = styled("span")(({ theme }) => ({
  backgroundColor: theme.palette.secondary1[60], // Highlight color from theme
  color: theme.palette.primary.main,
  fontWeight: 500,
  textTransform: "none",
}));

export interface TextHighlightProps {
  text: string;
  searchText: string;
}

function TextHighlight({ text, searchText }: TextHighlightProps) {
  return useMemo(() => {
    if (!searchText || !text) {
      return <>{text}</>;
    }

    try {
      const parts: string[] = StringHelpers.splitDiacriticStrings(text, searchText);

      return (
        <>
          {parts.map((part, index) => {
            // Check if this part matches the search text (case-insensitive)
            const isMatch =
              StringHelpers.removeDiacritics(part).toLowerCase() ===
              StringHelpers.removeDiacritics(searchText).toLowerCase();

            return isMatch ? <HighlightedSpan key={index}>{part}</HighlightedSpan> : part;
          })}
        </>
      );
    } catch (error) {
      // Fallback if regex fails
      return <>{text}</>;
    }
  }, [text, searchText]);
}

export default TextHighlight;
